import { useLoading } from 'providers/loading';
import {
  NavigateFunction,
  NavigateOptions,
  useLocation,
  useNavigate as useNavigateDefault,
} from 'react-router-dom';
import { parseCityId, withCityId } from 'utils/city-url';
import { CITY_QUERY_PARAM } from 'constants/city';

export const useNavigate = () => {
  const navigateDefault = useNavigateDefault();
  const location = useLocation();
  const { setLoading } = useLoading();

  const navigate: NavigateFunction = (...args) => {
    setLoading(false);

    if (typeof args[0] === 'number') {
      navigateDefault(...(args as [any, any]));
      window.scrollTo(0, 0);

      return;
    }

    const currentCityId = parseCityId(
      new URLSearchParams(location.search).get(CITY_QUERY_PARAM),
    );
    const nextTarget = withCityId(args[0], currentCityId);

    navigateDefault(nextTarget, args[1] as NavigateOptions | undefined);
    window.scrollTo(0, 0);
  };

  return navigate;
};
